export const getFilterSignType = state => state.signType.filter
